if (!customElements.get("limit-notice-cp")) {
  customElements.define(
    "limit-notice-cp",
    class LimitNoticeCP extends HTMLElement {
      constructor() {
        super();

        /**
         * @type {(evt: MouseEvent) => void}
         */
        this.boundClickListener = this.clickListener.bind(this);

        this.noticeTextTemplate =
          "You've reached the purchase limit for this [limit-type]";
        this.noticeActive = false;
        this.noticeActive = false;
      }

      async connectedCallback() {
        this.limitReached = false;

        /**
         * @type {HTMLElement | null}
         */
        this.notice = this.querySelector(".limit-alert");
        const parent = this.parentElement;
        this.buyButton = parent ? parent.querySelector("button") : null;
        this.wrapper = this.parentElement;

        const cart = await store.getCart();
        this.product = JSON.parse(
          /** @type {string} */ (
            /** @type {HTMLScriptElement} */ (
              this.querySelector('script[type="application/json"]')
            ).textContent
          )
        );

        this.productId = this.product.id;
        this.vendor = this.product.vendor;

        this.hasCustomText = this.dataset.hasCustomText;

        this.productLimit = store.getLimitForProduct(this.product.id);
        this.brandLimit = store.getLimitForBrand(this.product.vendor);
        if (
          !this.productLimit &&
          !this.brandLimit &&
          window.enableGlobalProductLimit
        ) {
          this.productLimit = window.globalProductLimit;
        }
        this.limitType = this.productLimit ? "product" : "brand";

        this.hasExactlyOneOption =
          this.product.options.length === 1 ? true : false;
        this.isRenderedOnModalSwiper = this.closest("swiper-variants-mobile")
          ? true
          : false;

        this.boundClickListener = this.clickListener.bind(this);

        this.checkLimits(cart);
        this.initMessage();

        messenger.listen(
          messenger.topics.CHECK_LIMITS,
          (cart) => {
            // console.log(
            //   `Limit-notice-CP on ${this.product.title} received Check limits, cart: ${cart}`
            // );
            this.checkLimits(cart);
          },
          "LimitNotice"
        );
      }

      disconnectedCallback() {
        if (this.wrapper) {
          this.wrapper.removeEventListener("click", this.boundClickListener, {
            capture: true,
          });
        }
      }

      /**
       *
       * @param {MouseEvent} evt
       * @returns {void}
       */
      clickListener(evt) {
        if (evt) {
          evt.preventDefault();
          evt.stopPropagation();
        }
        if (!this.notice) {
          console.error("Cannot find notice-element...");
          return;
        }
        this.notice.style.display = "flex";
        setTimeout(() => {
          if (!this.notice) {
            console.error("Cannot find notice-element...");
            return;
          }
          this.notice.style.display = "none";
        }, 3000);
      }

      async initMessage() {
        const limitText = this.notice?.querySelector(".limit_text");
        if (!limitText) {
          console.log("Cannot find limitText element...");
          return;
        }
        const productLimitString = this.productLimit
          ? this.productLimit.toString()
          : "";
        const brandLimitString = this.brandLimit
          ? this.brandLimit.toString()
          : "";

        limitText.innerHTML = this.noticeTextTemplate
          .replace("[limit-type]", this.limitType || "")
          .replace(
            "[limit-qty]",
            this.limitType && this.limitType === "product"
              ? productLimitString
              : brandLimitString
          );
      }

      setNoticeActive() {
        // Return if notice is rendered on a product card with exactly one option and on mobile. Limit notice will be displayed on the swiper-modal instead
        // console.log('hasExactlyOneOption', this.hasExactlyOneOption);
        // console.log('window.innerWidth', window.innerWidth);
        // console.log('isRenderedOnModalSwiper', this.isRenderedOnModalSwiper);

        const renderedOnMobile = window.innerWidth < 768;
        // if (
        //   this.hasExactlyOneOption &&
        //   window.innerWidth < 768 &&
        //   !this.isRenderedOnModalSwiper
        // ) {
        //   console.log('returning');
        //   return;
        // }

        if (this.buyButton) {
          this.buyButton.type = "button";
        }

        this.limitReached = true;

        if (!this.wrapper || this.noticeActive) {
          return;
        }

        this.classList.add("limit-notice-cp--active");

        this.wrapper.addEventListener("click", this.boundClickListener, {
          capture: true,
        });
        this.noticeActive = true;
      }

      setNoticeDeactive() {
        const holidayShippingExpired = this.checkForHolidayShippingExpired();
        if (this.buyButton && !holidayShippingExpired && !this.hasCustomText) {
          this.buyButton.type = "submit";
        }
        this.limitReached = false;
        this.noticeActive = false;

        this.dataset.limitNoticeActive = false;

        this.wrapper.removeEventListener("click", this.boundClickListener, {
          capture: true,
        });
      }

      checkForHolidayShippingExpired() {
        const holidayShippingCountdown = document.querySelector(
          "holiday-shipping-countdown"
        );
        if (!holidayShippingCountdown) {
          return false;
        }
        const expiredElement = holidayShippingCountdown.querySelector(
          ".holiday-shipping-expired-container"
        );
        if (!expiredElement) {
          return false;
        }
        return expiredElement.style.display === "block";
      }

      async checkLimits(cart) {
        // console.log("Limit-notice checking limits for vendor: ", this.vendor);
        // console.log("Limit-notice checking limits for product: ", this.product.id);
        if (!this.product || !this.vendor) {
          console.log("cannot check limits, no product or vendor found");
          return;
        }
        const limitStatus = await knocking.returnLimitStatus(
          cart,
          1,
          this.product.id,
          this.vendor
        );

        if (!limitStatus || limitStatus.type === "none") {
          return;
        }

        if (limitStatus && !limitStatus.remainingQty > 0) {
          // console.log('limit reached');
          this.setNoticeActive();
          this.showNotice();
        } else {
          this.setNoticeDeactive();
          this.hideNotice();
        }
      }

      showNotice() {
        this.notice.style.display = "flex";
        setTimeout(this.hideNotice(), 3000);
      }

      hideNotice() {
        this.notice.style.display = "none";
      }
    }
  );
}
